module.exports = __webpack_public_path__ + "img/FONDOPANTCDMX01.231b67e1.png";